import { z } from "zod";
import { type FpChat, FpChatSchema } from "./codegen";

export const ChatCreatedEventSchema = z.object({
  type: z.literal("chat.created"),

  chat: FpChatSchema,
});
export type ChatCreatedEvent = z.infer<typeof ChatCreatedEventSchema>;

export function createChatCreatedEvent(chat: FpChat): ChatCreatedEvent {
  return {
    type: "chat.created",
    chat,
  };
}

export const ChatUpdatedEventSchema = z.object({
  type: z.literal("chat.updated"),

  chat: FpChatSchema,
});
export type ChatUpdatedEvent = z.infer<typeof ChatUpdatedEventSchema>;

export function createChatUpdatedEvent(chat: FpChat): ChatUpdatedEvent {
  return {
    type: "chat.updated",
    chat,
  };
}

export const ChatDeletedEventSchema = z.object({
  type: z.literal("chat.deleted"),

  chatId: z.string().nanoid(),
});
export type ChatDeletedEvent = z.infer<typeof ChatDeletedEventSchema>;

export function createChatDeletedEvent(chatId: string): ChatDeletedEvent {
  return {
    type: "chat.deleted",
    chatId,
  };
}

export const EventsSchema = z.discriminatedUnion("type", [
  ChatCreatedEventSchema,
  ChatUpdatedEventSchema,
  ChatDeletedEventSchema,
]);
export type Events = z.infer<typeof EventsSchema>;
